export const GET_JOBS = 'job/GET_JOBS'
export const GET_JOB = 'job/GET_JOB'
export const ADD_JOB = 'job/ADD_JOB'
export const EDIT_JOB = 'job/EDIT_JOB'
export const DELETE_JOB = 'job/DELETE_JOB'
export const RESET_JOB = 'job/RESET_JOB'
